import { FeatureType } from 'app/model/constant';

import { AddressesUserProfileModel } from '../../model/profile/profile.model';
import { AttachFileFeature } from '../../model/feature/attach-file-feature.model';
import { BillingAddressFeature } from 'app/model/feature/billing-address-feature.model';
import { CostCenterAddressModel } from '../../model/checkout/cost-center-address.model';
import { CostCenterFeature } from '../../model/feature/cost-center-feature.model';
import { Injectable } from '@angular/core';
import { UserService } from 'app/services/user/user.service';
import { InternalOrderFeature } from 'app/model/feature/internal-order-feature.model';

@Injectable()
export class UserFeatureService {

  constructor(
    private userService: UserService
  ) { }

  getAvailableFeatureData<T>(featureType: string): T {
    const feature = this.userService.getUserFeature(featureType);
    const { data } = feature || { data: undefined };
    let featureData: any;
    switch (featureType) {
      case FeatureType.checkout3BillingAddress:
        featureData = new BillingAddressFeature(data);
        break;
      case FeatureType.checkout3DocumentAttach:
        featureData = new AttachFileFeature(data);
        break;
      case FeatureType.checkout3CostCenter:
        featureData = new CostCenterFeature(data);
        break;
      case FeatureType.checkout3InternalOrder:
        featureData = new InternalOrderFeature(data);
        break;
      default:
        featureData = undefined;
        break;
    }
    return featureData;
  }

  canChangePassword() {
    const feature = this.userService.getUserFeature(FeatureType.ALLOW_CHANGE_PASSWORD, true);
    return feature ? feature.allow : false;
  }

  canEditProfile() {
    const feature = this.userService.getUserFeature(FeatureType.ALLOW_EDIT_PROFILE, true);
    return feature ? feature.allow : false;
  }

  getCostCenterData(costCenterFeature: CostCenterFeature): CostCenterFeature {
    return costCenterFeature && costCenterFeature.display ? costCenterFeature : null;
  }

  checkUseDefaultCostCenter(costCenter: CostCenterFeature): boolean {
    const { costCenter: costCenterData } = costCenter || { costCenter: undefined };
    const { costCenterName: costCenterNameData } = costCenter || { costCenterName: undefined };
    const { defaultAddress: defaultAddressData } = costCenter || { defaultAddress: undefined };
    const haveCostCenter = !!costCenterData && costCenterData !== '';
    const haveCostCenterName = !!costCenterNameData && costCenterNameData !== '';
    const haveDefaultAddress = !!defaultAddressData;
    return haveCostCenter && haveCostCenterName && haveDefaultAddress;
  }

  transformCostCenterAddressToAddressModel(address: CostCenterAddressModel) {
    let newAddress = null;
    if (address) {
      newAddress = new AddressesUserProfileModel();
      newAddress.title = address.companyTitle;
      newAddress.taxNumber = address.taxNumber;
      newAddress.address = address.address;
    }

    return newAddress;
  }

  canShowApprovalList() {
    const feature = this.userService.getUserFeature(FeatureType.ALLOW_SUPERVISOR_APPROVAL, true);
    return feature ? (feature.data ? feature.data.postApproval : false) : false;
  }

  canShowShareBudget() {
    const feature = this.userService.getUserFeature(FeatureType.ALLOW_SHARE_BUDGET, true);
    return feature ? feature.allow : false;
  }

  isAllowBudgetLimit() {
    const allowLimitBudgetFeature = this.userService.getUserFeature(FeatureType.ALLOW_LIMIT_BUDGET);
    const allowCreditTermsFeature = this.userService.getUserFeature(FeatureType.ALLOW_CREDIT_TERMS);
    const allowCorporateFleetFeature = this.userService.getUserFeature(FeatureType.ALLOW_CORPORATE_FLEET);
    return allowLimitBudgetFeature && allowLimitBudgetFeature.allow && (allowCreditTermsFeature.allow || allowCorporateFleetFeature.allow);
  }

  enablePreApprovalRequester() {
    const enablePreApproval = this.userService.getUserFeature(FeatureType.ENABLE_PRE_APPROVAL, true);
    const hasApprovalRequest = enablePreApproval && enablePreApproval.data && enablePreApproval.data.hasApprovalRequest;
    return ((enablePreApproval && enablePreApproval.allow) || hasApprovalRequest);
  }

  enablePreApprovalApprover() {
    const feature = this.userService.getUserFeature(FeatureType.ALLOW_SUPERVISOR_APPROVAL, true);
    return feature ? (feature.data ? feature.data.preApproval : false) : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user-feature/user-feature.service.ts